import { useSearchParams } from 'react-router-dom';

import { useGetWholesaleAdminCustomersQuery } from '@/features/slice/wholesale-admin';

import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_NUMBER } from '../../../constants';

export const useWholesaleAdminOrderCustomers = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = Number(searchParams.get('page')) || DEFAULT_PAGE_NUMBER;

  const setCurrentPage = (page: number) => {
    searchParams.set('page', page.toString());
    setSearchParams(searchParams);
  };

  const { data, error, isLoading } = useGetWholesaleAdminCustomersQuery({
    limit: DEFAULT_PAGE_LIMIT,
    page: currentPage,
    sort_by: 'name',
    sort_order: 'asc',
  });
  return { data, error, isLoading, currentPage, setCurrentPage };
};
